import { PlatformProfileSource } from "../@types"
import { createPlatformFeatures, PlatformFeatures } from "./platformFeatures"
import { createProfileTestObject, ProfileTestObject } from "./profileTestObject"

export interface PlatformProfile {
  cdnResponseHeader: string | undefined
  profileFeatures: PlatformFeatures
  profileTestObjects: ProfileTestObject[]
}

export const createPlatformProfile: (
  source: PlatformProfileSource,
  continent: string,
  country: string,
) => PlatformProfile = (source, continent, country) =>
  new PlatformProfileImpl(source, continent, country)

class PlatformProfileImpl implements PlatformProfile {
  // Prefer assignment in constructor to avoid compiler using
  // Object.defineProperty, which breaks property munging
  private _cdnResponseHeader?
  private _profileFeatures
  private _profileTestObjects
  constructor(
    source: PlatformProfileSource,
    reporterContinent: string,
    reporterCountry: string,
  ) {
    /* eslint-disable @typescript-eslint/dot-notation */
    this._profileTestObjects = [] as ProfileTestObject[]
    const tempCdnResponseHeader = source["cdn_response_header"]
    if (
      typeof tempCdnResponseHeader === "string" &&
      tempCdnResponseHeader.length
    ) {
      this._cdnResponseHeader = tempCdnResponseHeader
    }
    const tempObjects = source["objects"]
    if (typeof tempObjects === "object") {
      this._profileTestObjects = tempObjects.map((sourceConfig) =>
        createProfileTestObject(
          sourceConfig,
          reporterContinent,
          reporterCountry,
        ),
      )
    }
    this._profileFeatures = createPlatformFeatures(source["features"] || {})
    /* eslint-enable @typescript-eslint/dot-notation */
  }

  get cdnResponseHeader() {
    return this._cdnResponseHeader
  }

  get profileFeatures() {
    return this._profileFeatures
  }

  get profileTestObjects() {
    return this._profileTestObjects
  }
}
